import React from "react";
import DefaultLayout from "../../layout/DefaultLayout";
import BreadcrumbTwo from "../../components/Breadcrumbs/BreadcrumbTwo";
import EnabledDocumentTypesTable from "../../components/Hacienda/EnabledDocumentTypes/EnabledDocumentTypesTable";

const EnabledDocumentTypesPage: React.FC = () => {
  return (
    <DefaultLayout>
      <BreadcrumbTwo />
      <EnabledDocumentTypesTable/>
    </DefaultLayout>
  );
};

export default EnabledDocumentTypesPage;
